import FormField from "@src/components/form-field"
import InputField from "@src/components/input-field"
const FormFieldInput = FormField(InputField)
export default FormFieldInput
